export const formType = {
    ON_SHOW_MESSAGE: "ON_SHOW_MESSAGE"
}